module.exports = "https://web-assets-production.autolist.com/_next/static/images/luxury-bc1298d8856adafbabe6fdc918226155.png";